import { TYPE } from '../actions/types'

const initialState = {
    statesList: [],
    citiesList: [],
    areasList: [],
    regionList: [],
    hotelDetailsResponse: {},
    hotelData: {},
    addNewBankAccountResponse: {},
    validateGSTResponse: {},
    updateHotelResponse: {},
    uploadImageRes: {},
    uploadFulldayImgRes: {},
    uploadRegDocRes: {},
    loading: true,
    propertyCheckInCheckOutRes: {},
    editHotelInfoRes: {},

    updateInsertRegionRes: {},
    getRegionRes: {},
    addNewCityRes: {},
    fetchCityRes: {},
    allStateList: {},
    addNewAreaRes: {},
    updateNearbyAreas: {},
    getAreaRes: {},
    citiesRegion: {},
    updateRegionRes: {},
    linkCitiesWithRegionRes: {},
    getCitiesRes: {},
    searchAccountRes: {},
    linkAccountRes: {},
    paymentHoldApiResponse: {}
}

export default function (state = initialState, action, response = action.payload) {
    switch (action.type) {
        case TYPE.EDIT_HOTEL_INFO:
            state.editHotelInfoRes = response
            return { ...state, response: action.payload }

        case TYPE.GET_STATES:
            state.allStateList = action.payload;
            if (response.status === "SUCCESS") {
                state.statesList = response.states_list
            }
            else {
                state.statesList = []
            }
            return { ...state, response: action.payload }

        case TYPE.GET_REGIONS:
            state.getRegionRes = action.payload;
            if (response.status === "SUCCESS") {
                state.regionList = response.regions_list
            }
            else {
                state.regionList = []
            }
            return { ...state, response: action.payload }

        case TYPE.FETCH_CITIES:
            state.fetchCityRes = action.payload;
            return { ...state, response: action.payload }

        case TYPE.GET_CITIES:
            state.getCitiesRes = action.payload
            if (response.status === "SUCCESS") {
                state.citiesList = response.cities_list
            }
            else {
                state.citiesList = []
            }
            return { ...state, response: action.payload }

        case TYPE.CITIES_REGION:
            state.citiesRegion = action.payload;
            return { ...state, response: action.payload };

        case TYPE.UPDATE_REGION:
            state.updateRegionRes = action.payload;
            return { ...state, response: action.payload };

        case TYPE.LINK_CITIES_WITH_REGION:
            state.linkCitiesWithRegionRes = action.payload;
            return { ...state, response: action.payload };

        case TYPE.GET_AREA:
            state.getAreaRes = action.payload;
            if (response.status === "SUCCESS") {
                state.areasList = response.areas_list
            }
            else {
                state.areasList = []
            }
            return { ...state, response: action.payload }

        case TYPE.ADD_NEW_CITY:
            state.addNewCityRes = action.payload;
            return { ...state, response: action.payload }

        case TYPE.ADD_NEW_AREA:
            state.addNewAreaRes = action.payload;
            return { ...state, response: action.payload }

        case TYPE.SEARCH_ADMIN:
            return { ...state, response: action.payload }

        case TYPE.LINK_ADMIN_WITH_HOTEL:
            return { ...state, response: action.payload }

        case TYPE.UPDATE_HOTEL:
            state.updateHotelResponse = response
            return { ...state, response: action.payload }

        case TYPE.GET_HOTEL_DETAILS:
            if (response.status === "SUCCESS") {
                state.hotelDetailsResponse = response
                state.hotelData = response.hotelData[0]
                state.loading = false

                let linkedChannelManager = response.hotelData[0]?.linked_channel_managers

                console.log("response", linkedChannelManager);

                localStorage.setItem("linked_channel_managers", JSON.stringify(linkedChannelManager))

            }
            else {
                state.hotelDetailsResponse = {}
                state.hotelData = {}
                state.loading = false
            }
            return { ...state, response: action.payload }
        case TYPE.UPDATE_PROPERTY_CHECKIN_CHECKOUT:
            state.propertyCheckInCheckOutRes = response
            return { ...state, response: action.payload }
        case TYPE.GET_UNLISTED_HOTELS:
            return { ...state, response: action.payload }

        case TYPE.UPDATE_NEARBY_AREAS:
            state.updateNearbyAreas = action.payload;
            return { ...state, response: action.payload }

        case TYPE.UPLOAD_HOTEL_IMAGES:
            state.uploadImageRes = action.payload
            return { ...state, response: action.payload }
        case TYPE.GET_CLOSED_HOTELS:
            return { ...state, response: action.payload }
        case TYPE.ADD_NEW_ACCOUNT:
            state.addNewBankAccountResponse = response
            return { ...state, response: action.payload }
        case TYPE.SEARCH_ACCOUNT:
            state.searchAccountRes = response
            return { ...state, response: action.payload }
        case TYPE.LINK_ACCOUNT:
            state.linkAccountRes = response
            return { ...state, response: action.payload }
        case TYPE.UNLINK_ACCOUNT:
            return { ...state, response: action.payload }
        case TYPE.UPLOAD_REG_DOCS:
            state.uploadRegDocRes = action.payload
            return { ...state, response: action.payload }
        case TYPE.GST:
            state.validateGSTResponse = response
            return { ...state, response: action.payload }
        case TYPE.UPDATE_OR_INSERT_REGION:
            state.updateInsertRegionRes = action.payload;
            return { ...state, response: action.payload };
        case TYPE.UPDATE_PAYMENT_HOLD:
            state.paymentHoldApiResponse = action.payload;
            return { ...state, respo: action.payload }
        case "clear_update_hotel_res":
            state.updateHotelRes = {}
            return { ...state, response: action.payload }
        case TYPE.UPLOAD_FULLDAY_DETAILS_IMG:
            state.uploadFulldayImgRes = action.payload
            return { ...state, response: action.payload }
        case "clear_upload_fullday_images_res":
            state.uploadFulldayImgRes = {}
            return { ...state, response: action.payload }
        case "clear_upload_reg_docs":
            state.uploadRegDocRes = {}
            return { ...state, response: action.payload }
        case "clear_update_hotel_res":
            state.updateHotelRes = {}
            return { ...state, response: action.payload }
        case "clear_upload_image_res":
            state.uploadImageRes = {}
            return { ...state, response: action.payload }

        case "clear_edit_hotel_info_res":
            state.editHotelInfoRes = {}
            return { ...state, response: action.payload }
        case "clear_property_checkin_checkout":
            state.propertyCheckInCheckOutRes = {}
            return { ...state, response: action.payload }
        case "clear_search_link_bank_res":
            state.searchAccountRes = {}
            state.linkAccountRes = {}
            state.addNewBankAccountResponse = {}
            return { ...state, response: action.payload }
        case "clear_property_data":
            state.hotelDetailsResponse = {}
            state.hotelData = {}
            state.loading = true
            state.updateHotelResponse = {}
            return { ...state, response: action.payload }
        default:
            return state;
    }
}




